import { css } from '@emotion/react'

const dropdownBtn = css`
  width: 320px;
`

export const styles = {
  dropdownBtn,
}
